<template>
  <div class="c-project g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 项目 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModules" :key="item.id" :title="item.name">
        <!-- 基础信息 -->
        <template v-if="item.href === 'base_info'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">项目名称</span>
            </Col>
            <Col span="18">
              <input-len
                ref="planinput"
                v-model="formItem.name"
                placeholder="最大90个字符，1个中文等于2个字符"
                width="480"
                :max="90"
                disabled
                @on-focus="focusPlan"
                @on-blur="blurPlan"
              />
              <span style="margin-left: 12px" v-if="check">
                <Icon type="ios-loading" color="#5cadff" size="18" v-if="check === 'loading'" />
                <Icon type="md-checkmark" color="#19be6b" size="18" v-if="check === 'success'" />
                <Icon type="md-close" color="#ed4014" size="18" v-if="check === 'error'" />
                <span v-if="check === 'success'">标题可用</span>
                <span v-if="check === 'error'">此标题已被占用，请换一个！</span>
              </span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">应用平台</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.ch_platform_id" type="button">
                <Radio :label="1" disabled>Android</Radio>
                <Radio :label="2" disabled>iOS</Radio>
                <Radio :label="3" disabled>小程序</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放应用</span>
            </Col>
            <Col span="12">
              <span>{{ formItem.game_name }}</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="false">
            <Col span="3" class="col-item">
              <span class="item-field">自动化任务</span>
            </Col>
            <Col span="12">
              <span>{{ formItem.autoTaskStr }}</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">事件优化目标</span>
            </Col>
            <Col span="12">
              <span>{{ formItem.optimize_goal_name }}</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">回调开关</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.callback_switch" :true-value="1" :false-value="0" disabled />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.ch_platform_id === 1">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">头条分包</span>
            </Col>
            <Col span="12">
              <i-Switch v-model="formItem.ch_platform_id" :true-value="1" :false-value="0" disabled />
            </Col>
          </Row>
        </template>

        <!-- 营销目标及场景 -->
        <template v-if="item.href === 'purpose_scene'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">推广目的</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.landing_type" type="button">
                <Radio label="APP" disabled>应用推广</Radio>
                <Radio label="MICRO_GAME" disabled>小程序投放</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'MICRO_GAME'">
            <Col span="3" class="col-item">
              <span class="item-field">投放内容</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.micro_promotion_type" type="button">
                <Radio label="WECHAT_GAME" disabled>微信小游戏</Radio>
                <Radio label="BYTE_GAME" disabled>字节小游戏</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'MICRO_GAME'">
            <Col span="3" class="col-item">
              <span class="item-field">小游戏资产ID</span>
            </Col>
            <Col span="12">
              <el-input style="width: 320px" v-model="formItem.micro_app_instance_id" disabled></el-input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'APP'">
            <Col span="3" class="col-item">
              <span class="item-field">子目的</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.app_promotion_type" type="button">
                <Radio label="DOWNLOAD" disabled>应用下载</Radio>
                <Radio label="LAUNCH" disabled>应用调起</Radio>
                <Radio label="RESERVE" disabled>预约下载</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.app_promotion_type === 'RESERVE'">
            <Col span="3" class="col-item">
              <span class="item-field">预约链接</span>
            </Col>
            <Col span="12">
              <el-input disabled v-model="formItem.subscribe_url"></el-input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">关联星广联投任务</span>
            </Col>
            <Col span="12">
              <div>{{ starTaskName }}</div>
              <!-- 关联星广联投任务选择了任意一个才显示自动优选素菜开关 -->
              <div v-if="formItem.star_task_id" class="star-auto-material-switch">
                <el-switch disabled v-model="formItem.star_auto_material_addition_switch" active-value="ON" inactive-value="OFF">
                </el-switch>
                <p>自动优选素材：开启后系统会替换/暂停/删除本项目下计划素材</p>
              </div>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">营销场景</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.marketing_goal" type="button">
                <Radio label="VIDEO_AND_IMAGE" disabled>短视频+图文</Radio>
                <Radio label="LIVE" disabled>直播</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">计划类型</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.ad_type" type="button">
                <Radio label="ALL" disabled>所有计划</Radio>
                <Radio label="SEARCH" disabled>搜索计划</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.ad_type === 'ALL'">
            <Col span="3" class="col-item">
              <span class="item-field">投放模式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_mode" type="button">
                <Radio label="MANUAL" disabled>手动投放</Radio>
                <Radio label="PROCEDURAL" disabled>自动投放（UBMax）</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.ad_type === 'SEARCH'">
            <Col span="3" class="col-item">
              <span class="item-field">投放模式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_type" type="button">
                <Radio label="NORMAL" disabled>常规投放</Radio>
                <Radio label="DURATION" disabled>极速智投</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </template>

        <template v-if="formItem.ad_type === 'ALL' && item.href === 'search_bid' && formItem.delivery_mode === 'MANUAL'">
          <!-- 自动投放/小程序链路/投放范围仅穿山甲时不支持快投
          https://open.oceanengine.com/labels/7/docs/1740868093375503
           -->

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">开启</span>
            </Col>
            <Col span="12">
              <i-Switch style="position: relative; top: 3px" v-model="formItem.keywordSwitch" :true-value="1" :false-value="0" />
            </Col>
          </Row>

          <template v-if="formItem.keywordSwitch">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">关键词</span>
              </Col>
              <Col span="12">
                <el-input style="width: 280px" :value="searchBidTips" readonly placeholder="未添加关键词，待自动更新"></el-input>
                <el-button type="text" @click="onSearchKeywordAdd">编辑</el-button>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">出价系数</span>
              </Col>
              <Col span="12">
                <el-input
                  style="width: 280px"
                  v-model="formItem.search_bid_ratio"
                  placeholder="请输入1.00-2.00之间的值，最多2位小数"
                ></el-input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">定向扩展</span>
              </Col>
              <Col span="12" class="ghost-button-styles">
                <el-radio-group v-model="formItem.audience_extend">
                  <el-radio-button ghost label="ON">开启</el-radio-button>
                  <el-radio-button ghost label="OFF">不开启</el-radio-button>
                </el-radio-group>
              </Col>
            </Row>
          </template>
        </template>

        <!-- 版位及定向 -->
        <template v-if="item.href === 'pos_target'">
          <targeting
            ref="targeting"
            download-type="DOWNLOAD_URL"
            delivery-range="DEFAULT"
            :media="mediaId"
            :account="accountId"
            :accounts="multAccount"
            :plan="formItem.audience"
            :landing-type="formItem.landing_type"
            :ch-platform="formItem.ch_platform_id"
            :audience-loading="audienceLoading"
            :delivery-mode="formItem.delivery_mode"
            :data="{
              retargetData,
              unionRetargetData,
              articleData,
              brandData,
              brandDataAll,
              cityData,
              gategoryData,
              autotendData,
              androidVersion,
              iOSVersion
            }"
          />
        </template>

        <!-- 排期及预算 -->
        <template v-if="item.href === 'schedule_budget'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时间</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.schedule_type" type="button">
                <Radio label="SCHEDULE_FROM_NOW" disabled>从今天起长期投放</Radio>
                <Radio label="SCHEDULE_START_END" disabled>设置开始和结束日期</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="formItem.delivery_setting.schedule_type === 'SCHEDULE_START_END'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <Row>
                <Col span="24">
                  <span class="split-line">{{ formItem.delivery_setting.start_time }} ~ {{ formItem.delivery_setting.end_time }}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时段</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.timeRange" type="button">
                <Radio label="NONE" disabled>不限</Radio>
                <Radio label="RANGE" disabled>指定时间段</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="formItem.timeRange === 'RANGE'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <drag-weektime v-model="mult_timeRange" :data="weektimeData" disabled />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">竞价策略</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.bid_type" type="button">
                <Radio label="CUSTOM" disabled>稳定成本</Radio>
                <Radio label="UPPER_CONTROL" disabled>控制成本上限</Radio>
                <Radio label="NO_BID" disabled>最大转化</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">项目预算</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.budget_mode" type="button">
                <Radio label="BUDGET_MODE_INFINITE" disabled>不限</Radio>
                <Radio label="BUDGET_MODE_DAY" disabled>设置预算</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <!-- 只有最大转化的竞价策略且设置预算时，显示预算择优分配 -->
          <Row
            class="row-item"
            :gutter="12"
            v-if="formItem.delivery_setting.bid_type === 'NO_BID' && formItem.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'"
          >
            <Col span="3" class="col-item">
              <span class="item-field">预算择优分配(CBO)</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.budget_optimize_switch" type="button">
                <Radio disabled label="OFF">不启用</Radio>
                <Radio disabled label="ON">启用</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">日预算</span>
            </Col>
            <Col span="12">
              <input-number-plus
                :max="7"
                :min="300"
                :step="0.1"
                :maxNum="9999999.99"
                :precision="2"
                v-model="formItem.delivery_setting.budget"
                placeholder="预算不少于300元，不超过9999999.99元"
                :width="267"
              />
              <span style="margin-left: 10px">元</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="projectBidVisible">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">目标出价</span>
            </Col>
            <Col span="12">
              <input-number-plus
                :max="5"
                :min="0.1"
                :step="0.1"
                :maxNum="10000"
                :precision="2"
                v-model="formItem.delivery_setting.cpa_bid"
                placeholder="不少于0.1元，不超过10000元"
                :width="267"
              />
              <span style="margin-left: 10px">元</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">深度优化方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.deep_bid_type" type="button">
                <Radio label="DEEP_BID_DEFAULT" disabled>无深度优化</Radio>
                <Radio label="DEEP_BID_MIN" disabled>自定义双出价</Radio>
                <Radio label="ROI_COEFFICIENT" disabled>ROI系数</Radio>
                <Radio label="BID_PER_ACTION" disabled>每次付费</Radio>
                <Radio label="FIRST_AND_SEVEN_PAY_ROI" disabled>首日ROI+7日ROI</Radio>
                <Radio label="PER_AND_SEVEN_PAY_ROI" disabled>每次付费+7日ROI</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <template v-if="formItem.delivery_mode === 'PROCEDURAL' && formItem.delivery_setting.bid_type !== 'NO_BID'">
            <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.deep_bid_type === 'DEEP_BID_MIN'">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">深度目标出价</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  :max="5"
                  :min="0.1"
                  :step="0.1"
                  :maxNum="10000"
                  :precision="2"
                  v-model="formItem.delivery_setting.deep_cpabid"
                  placeholder="不少于0.1元，不超过10000元"
                  :width="267"
                />
              </Col>
            </Row>
            <Row
              class="row-item"
              :gutter="12"
              v-if="
                ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(formItem.delivery_setting.deep_bid_type)
              "
            >
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">ROI系数</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  :min="0.1"
                  :step="0.1"
                  :maxNum="5"
                  :precision="4"
                  v-model="formItem.delivery_setting.roi_goal"
                  placeholder="ROI系数不大于5，保留小数点后四位"
                  :width="267"
                />
              </Col>
            </Row>
          </template>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">监测链接</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px">
                <a
                  style="line-height: 16px; width: 360px; overflow-x: hidden; text-overflow: ellipsis"
                  v-clipboard:copy="formItem.track_chain_addr || 'ptom.caohua.com'"
                  v-clipboard:success="onCopy"
                >
                  {{ formItem.track_chain_addr || 'ptom.caohua.com' }}
                </a>
              </div>
            </Col>
          </Row>
        </template>
      </moduler>
    </div>

    <div class="c-project-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" :loading="loading" @click.stop="submit">
            <span v-if="!loading">保存并关闭</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>

    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="accountId"
      :list="searchBidKeywordList"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>
  </div>
</template>

<script>
import mixin from './mixin'
import { isEmpty, deepCopy, formatDate, splicing, isArray, getKeyOfData, pullKeys } from '@/common/js/utils'
import { checkPlanName } from '@/api/common.model'
import { getCustomAudience, getFlowPackage, actionId2Word } from '@/api/toutiao.model'
import { getProjectInfo, updateProject } from '@/api/convert.model'

import DragWeektime from '@/components/drag/drag-weektime.vue'
import Targeting from './components/targeting/'
import InputNumberPlus from '@/components/input/input-number-plus'
import SearchBidKeywordSelectModal from '@/views/create/toutiaonew_local/components/group/search-bid.vue'

import weektimeData from '@/data/toutiao/weektime_data'
import cityData from '@/data/toutiao/city_province'
import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import brandDataAll from '@/data/toutiao/brand_all_categroy'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'
import androidVersion from '@/data/toutiao/android_version'
import iOSVersion from '@/data/toutiao/ios_version'

import { getStarDeliveryTaskList } from '@/api/toutiao.local.model.js'

let Timer

const defaultTargetParams = {
  inventory_catalog: 'MANUAL', // 投放位置
  inventory_type: [
    'INVENTORY_FEED',
    'INVENTORY_VIDEO_FEED',
    'INVENTORY_AWEME_FEED',
    'INVENTORY_TOMATO_NOVEL',
    'INVENTORY_UNION_SLOT',
    'UNION_BOUTIQUE_GAME'
  ],
  union_video_type: 'REWARDED_VIDEO', // 投放形式
  district: 'NONE', // 地域类型
  location_type: 'HOME', // 受众位置类型
  gender: 'NONE', // 受众性别
  age: 'NONE', // 受众年龄区间
  tags: 'NONE', // 兴趣分类
  interest_action_mode: 'UNLIMITED', // 行为兴趣定向
  action_scene: [], // 行为场景
  action_days: 30, // 行为天数
  action_tags: [], // 行为定向
  word_tags: [], // 兴趣定向
  ac: 'NONE', // 受众网络类型
  carrier: 'NONE', // 受众运营商
  activate_type: 'NONE', // 用户首次激活时间
  brand: 'NONE', // 受众手机品牌
  price: 'NONE', // 手机价格
  article: 'NONE', // 受众文章分类
  retargeting_type: 'NONE', // 定向与排除
  app_behavior_target: 'NONE', // APP行为定向
  platform: ['ANDROID'], // 受众平台
  android_osv: '0.0', // Android版本
  ios_osv: '0.0',
  hide_if_converted: 'NO_EXCLUDE',
  launch_price: [], // 手机价格
  superior_popularity_type: 'NONE', // 流量位置
  device: 'NONE',
  device_type: [], // 设备类型
  retargeting_tags_include: [],
  retargeting_tags_exclude: [],
  flow_package: [],
  exclude_flow_package: [],
  auto_extend_enabled: 'OFF', // 智能放量
  fan_tags: [],
  aweme_talents: 'NONE',
  aweme_fan_behaviors: [],
  aweme_fan_time_scope: 'FIFTEEN_DAYS',
  filter_aweme_abnormal_active: 0, // 过滤高活跃用户
  filter_own_aweme_fans: 0, // 过滤自己的粉丝
  filter_aweme_fans_count: 0 // 过滤高关注数用户
}

export default {
  name: 'project',
  mixins: [mixin],
  components: { DragWeektime, Targeting, InputNumberPlus, SearchBidKeywordSelectModal },
  computed: {
    multAccount() {
      return [
        {
          id: Number(this.accountId),
          name: '本账号',
          mediaId: 10
        }
      ]
    },
    mult_timeRange() {
      const arr = []
      this.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    },
    searchBidTips() {
      const len = this.searchBidKeywordList.length
      if (len) {
        const [firstItem] = this.searchBidKeywordList
        return `已选${firstItem.keyword}...共${len}个关键词`
      }
      return '未添加关键词，待自动更新'
    },
    isSearch() {
      const { ad_type } = this.formItem
      return ad_type === 'SEARCH'
    },
    isDuration() {
      return this.isSearch && this.formItem.delivery_type === 'DURATION'
    },
    isNormal() {
      return this.isSearch && this.formItem.delivery_type === 'NORMAL'
    },
    projectBidVisible() {
      const { delivery_mode, ad_type, delivery_setting } = this.formItem
      const { bid_type } = delivery_setting
      if (this.isSearch) {
        // 搜索广告：极速智投可设置项目出价
        if (this.isDuration) return true
        // 搜索广告：常规投放稳定成本可设置项目出价
        return this.isNormal && bid_type === 'CUSTOM'
      }
      return delivery_mode === 'PROCEDURAL' && bid_type === 'CUSTOM'
    },
    starTaskName() {
      const { star_task_id } = this.formItem
      return this.starTaskList.find((task) => task.star_task_id === star_task_id)?.star_task_name || '-'
    }
  },
  methods: {
    onSearchKeywordAdd() {
      this.showSearchBidKeywordModal = true
    },
    onSearchKeywordSelectConfirm(list) {
      // 用于再次打开回显
      this.searchBidKeywordList = list
      // 用于项目提交
      this.formItem.keywords = list.map((item) => ({ word: item.keyword, bid_type: 'FEED_TO_SEARCH', match_type: item.patern.value }))
    },
    getData() {
      getProjectInfo({
        accountId: this.accountId,
        projectId: this.projectId
      }).then((data) => {
        setTimeout(() => {
          this.$Spin.hide()
        }, 1000)
        if (data) {
          const { out_plan_info, plan_info } = data
          if (plan_info) {
            Object.assign(this.formItem, plan_info)
          }
          if (out_plan_info) {
            const { audience, delivery_range, delivery_setting, keywords, audience_extend, advertiser_id } = out_plan_info

            getStarDeliveryTaskList({ advertiserId: advertiser_id, adAccount: advertiser_id }).then((data) => {
              if (data) {
                this.starTaskList = data
              }
            })

            if (audience_extend) {
              this.$set(this.formItem, 'keywordSwitch', 1)
            }

            // 搜索快投
            if (keywords?.length) {
              const paternList = [
                { label: '广泛', value: 'EXTENSIVE' },
                { label: '短语', value: 'PHRASE' },
                { label: '精确', value: 'PRECISION' }
              ]
              this.searchBidKeywordList = keywords.map((item) => {
                const patern = paternList.find((patern) => patern.value === item.match_type)
                return {
                  keyword: item.word,
                  patern: { ...patern }
                }
              })
            }

            const scheduleStat = delivery_setting.schedule_time.split('').every((ret) => ret === '1')
            if (!scheduleStat) {
              this.formItem.timeRange = 'RANGE'
              this.reverWeektime(delivery_setting.schedule_time)
            }
            // 定向参数解析
            // #1合并版位参数
            Object.assign(audience, delivery_range)
            const {
              city,
              district,
              age,
              interest_action_mode,
              action_scene,
              action_days,
              auto_extend_targets,
              ac,
              carrier,
              activate_type,
              article_category,
              device_brand,
              device_type,
              android_osv,
              launch_price,
              ios_osv,
              retargeting_tags_include,
              retargeting_tags_exclude,
              flow_package,
              exclude_flow_package,
              platform
            } = audience
            if (!platform) {
              this.$set(audience, 'platform', 'NONE')
            }
            if (isArray(ac) && !ac.length) this.$set(audience, 'ac', 'NONE')
            if (isArray(age) && !age.length) this.$set(audience, 'age', 'NONE')
            if (isArray(carrier) && !carrier.length) this.$set(audience, 'carrier', 'NONE')
            if (isArray(activate_type) && !activate_type.length) this.$set(audience, 'activate_type', 'NONE')
            if (isArray(article_category) && article_category.length) this.$set(audience, 'article', 'ARTICLE')
            if (isArray(device_brand) && device_brand.length) this.$set(audience, 'brand', 'BRAND')
            if (isArray(device_type) && !device_type.length) this.$set(audience, 'device', 'NONE')
            else if (isArray(device_type)) this.$set(audience, 'device', 'DEVICE')
            else {
              this.$set(audience, 'device', 'NONE')
              this.$set(audience, 'device_type', [])
            }
            // 头条地域字段更改,如果之前取值的是CITY,更改为REGION,使其正确地回显 v4.28.0 20230718
            if (district === 'CITY') this.$set(audience, 'district', 'REGION')

            if (android_osv === 'NONE') this.$set(audience, 'android_osv', '0.0')
            if (ios_osv === 'NONE') this.$set(audience, 'ios_osv', '0.0')
            if (isArray(launch_price) && !launch_price.length) {
              this.$set(audience, 'price', 'NONE')
              this.$set(audience, 'launch_price', [0, 11000])
            } else if (isArray(launch_price) && launch_price[0] === 0 && launch_price[1] === 11000) this.$set(audience, 'price', 'NONE')
            else if (isArray(launch_price)) this.$set(audience, 'price', 'CUSTOM')
            else this.$set(audience, 'price', 'NONE')
            let actionIdWord = []
            let tagsIdWord = []
            if (interest_action_mode === 'CUSTOM') {
              audience.action_tags = []
              audience.word_tags = []
              if (!isArray(audience.action_categories)) {
                audience.action_categories = []
              }
              if (!isArray(audience.action_words)) {
                audience.action_words = []
              }
              ;(async () => {
                actionIdWord = await this.id2word(audience.action_categories, audience.action_words, action_days, action_scene)
              })()
              if (!isArray(audience.interest_categories)) {
                audience.interest_categories = []
              }
              if (!isArray(audience.interest_words)) {
                audience.interest_words = []
              }
              ;(async () => {
                tagsIdWord = await this.id2word(audience.interest_categories, audience.interest_words)
                console.log(tagsIdWord)
              })()
            }
            audience.retargeting_type = 'RETARGETING_INCLUDE'
            if (
              (!isArray(retargeting_tags_include) || !retargeting_tags_include.length) &&
              (!isArray(retargeting_tags_exclude) || !retargeting_tags_exclude.length)
            ) {
              audience.retargeting_type = 'NONE'
            }
            for (const key in audience) {
              if (!audience[key]) delete audience[key]
            }
            if ((isArray(exclude_flow_package) && exclude_flow_package.length) || (isArray(flow_package) && flow_package.length)) {
              audience.superior_popularity_type = 'CUSTOM'
            }
            for (const key in audience) {
              if (!audience[key]) delete audience[key]
            }

            // 深度无枚举值兼容
            if (!delivery_setting.deep_bid_type) this.$set(out_plan_info.delivery_setting, 'deep_bid_type', 'DEEP_BID_DEFAULT')
            setTimeout(() => {
              this.decompile(city, 'cityData')
              this.decompileKey(device_brand, 'brandData')
              this.decompileKey(device_brand, 'brandDataAll')
              this.decompileKey(article_category, 'articleData')
              this.decompileKey(auto_extend_targets, 'autotendData')
              this.watchIncludes(this.retargetData, retargeting_tags_include)
              this.watchexcludes(this.retargetData, retargeting_tags_exclude)
              this.watchIncludes(this.unionRetargetData, flow_package)
              this.watchexcludes(this.unionRetargetData, exclude_flow_package)
              // 组件内部请求影响，延迟设置兴趣行为
              this.$set(audience, 'word_tags', tagsIdWord)
              this.$set(audience, 'action_tags', actionIdWord)
              delete out_plan_info.audience
              Object.assign(this.formItem, out_plan_info)
              Object.assign(this.formItem.audience, audience)
            }, 1000)
          }
          // 基本信息
        }
      })
    },
    async id2word(cate_ids, word_ids, day, scene) {
      const params = {}
      const getWords = []
      // 行为
      if (day) {
        Object.assign(params, {
          ad_account_id: this.accountId,
          targeting_type: 'ACTION',
          action_scene: scene.join(','),
          action_days: day
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      } else {
        Object.assign(params, {
          ad_account_id: this.accountId,
          targeting_type: 'INTEREST'
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      }
      const data = await Promise.all(getWords)
      const [cates, words] = data
      let cate_tags = []
      let word_tags = []
      if (cates && isArray(cates.categories)) {
        cate_tags = cates.categories.map((ret) => {
          ret.type = 'CATEGORY'
          return ret
        })
      }
      if (!cate_ids.length && word_ids.length && cates && isArray(cates.keywords)) {
        word_tags = cates.keywords.map((ret) => {
          ret.type = 'KEYWORD'
          return ret
        })
      } else if (words && isArray(words.keywords)) {
        word_tags = words.keywords.map((ret) => {
          ret.type = 'KEYWORD'
          return ret
        })
      }
      if (day) return [...cate_tags, ...word_tags]
      else return [...cate_tags, ...word_tags]
    },
    decompile(Ids, data) {
      this.radioChange(data)
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(this[data], 'id', ret)
          deepSelect([item])
        })
      }
    },
    decompileKey(vals, data) {
      this.radioChange(data)
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(vals) && vals.length) {
        vals.forEach((ret) => {
          const item = getKeyOfData(this[data], 'key', ret)
          deepSelect([item])
        })
      }
    },
    focusPlan() {
      Timer && clearTimeout(Timer)
    },
    blurPlan() {
      Timer = setTimeout(() => {
        this.checkPlan()
      }, 1000)
    },
    checkPlan() {
      const name = deepCopy(this.formItem.name)
      if (isEmpty(name)) return
      this.check = 'loading'
      checkPlanName({ planName: name })
        .then((data) => {
          this.check = data ? 'success' : 'error'
        })
        .catch(() => {
          this.check = 'error'
        })
    },
    reverWeektime(schedule) {
      let idx = 0
      for (let i = 0; i < this.weektimeData.length; i++) {
        const children = this.weektimeData[i].child
        for (let j = 0; j < children.length; j++) {
          const n = schedule.substr(idx, 1)
          this.$set(this.weektimeData[i].child[j], 'check', Boolean(parseInt(n)))
          idx++
        }
      }
    },
    onCopy() {
      this.$Message.success('复制点击监测链接成功！')
    },
    watchIncludes(data, list) {
      if (isArray(list) && list.length && data.length) {
        list.forEach((ret) => {
          const item = getKeyOfData(data, 'id', ret)
          this.$set(item, 'select', 'include')
        })
      }
    },
    watchexcludes(data, list) {
      if (isArray(list) && list.length && data.length) {
        list.forEach((ret) => {
          const item = getKeyOfData(data, 'id', ret)
          this.$set(item, 'select', 'exclude')
        })
      }
    },
    preload() {
      this.audienceLoading = true
      Promise.all([getCustomAudience({ account: this.accountId }), getFlowPackage({ account: this.accountId })])
        .then((data) => {
          this.audienceLoading = false
          const [audienceData, flowPackageData] = data
          if (audienceData && audienceData.success) {
            if (isArray(audienceData.models.retData)) {
              this.retargetData = audienceData.models.retData.map((ret) => {
                return {
                  id: ret.custom_audience_id,
                  name: ret.name,
                  source: ret.source
                }
              })
            }
          }
          if (isArray(flowPackageData)) {
            const flowPackage = flowPackageData.filter((ret) => ret.status === 'FLOW_PACKAGE_ENABLE')
            this.unionRetargetData = flowPackage.map((ret) => {
              return {
                id: ret.flow_package_id,
                key: ret.flow_package_id,
                name: ret.name
              }
            })
          }
          this.watchIncludes(this.retargetData, this.formItem.audience.retargeting_tags_include)
          this.watchexcludes(this.retargetData, this.formItem.audience.retargeting_tags_exclude)
          this.watchIncludes(this.unionRetargetData, this.formItem.audience.flow_package)
          this.watchexcludes(this.unionRetargetData, this.formItem.audience.exclude_flow_package)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submit() {
      let target_keys = [
        'district',
        'city',
        'location_type',
        'gender',
        'age',
        'career',
        'retargeting_tags_include',
        'retargeting_tags_exclude',
        'interest_action_mode',
        'action_scene',
        'action_days',
        'action_categories',
        'action_words',
        'interest_categories',
        'interest_words',
        'flow_package',
        'exclude_flow_package',
        'superior_popularity_type',
        'platform',
        'android_osv',
        'ios_osv',
        'device_type',
        'ac',
        'carrier',
        'hide_if_converted',
        'activate_type',
        'device_brand',
        'launch_price',
        'auto_extend_enabled',
        'auto_extend_targets'
      ]
      const { name, audience, delivery_setting, ad_type, delivery_mode, delivery_type } = this.formItem
      console.log(' this.formItem output: ', this.formItem)
      audience.retargeting_tags_include = this.retargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
      audience.retargeting_tags_exclude = this.retargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      audience.flow_package = this.unionRetargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
      audience.exclude_flow_package = this.unionRetargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      const targetParams = deepCopy(audience)
      // 定向参数不填（不填不代表填null）或者填固定的不限格式均可以设置对应受众为不限，string类型受众设置无限的常量统一可使用"NONE"，list类型的受众设置无限统一使用空数组，即[]
      const typeArrKeys = [
        'age',
        'career',
        'platform',
        'device_type',
        'ac',
        'carrier',
        'activate_type',
        'device_brand',
        'launch_price',
        'auto_extend_targets'
      ]
      for (const key of typeArrKeys) {
        if (targetParams[key] === 'NONE') targetParams[key] = []
      }
      if (targetParams.superior_popularity_type === 'CUSTOM') {
        delete targetParams.superior_popularity_type
      }
      // 平台仅选择iOS时，不传手机品牌
      if (
        targetParams.platform &&
        isArray(targetParams.platform) &&
        targetParams.platform.includes('IOS') &&
        targetParams.platform.length === 1
      ) {
        targetParams.device_brand = []
      }
      if (targetParams.superior_popularity_type === 'CUSTOM') {
        delete targetParams.superior_popularity_type
      }
      if (this.formItem.ad_type === 'SEARCH') {
        if (this.formItem.delivery_type === 'DURATION') {
          delete targetParams.device_brand
        }

        delete targetParams.device_type
        delete targetParams.ac
        delete targetParams.launch_price
      }

      this.formErr = false
      this.errRes = []
      if (this.formItem.ad_type === 'ALL' && this.formItem.delivery_mode === 'PROCEDURAL') {
        if (this.formItem.audience?.retargeting_tags_include?.length) {
          this.errRes.push({ feild: '人群包', msg: '自动投放时仅支持排除类型的人群包' })
        }
        const { delivery_setting } = this.formItem
        const { cpa_bid, budget } = delivery_setting
        if (cpa_bid && budget && cpa_bid > budget) {
          this.errRes.push({ feild: '出价', msg: '目标出价不能大于日预算' })
        }
        // 自动投放定向仅支持以下字段
        target_keys = [
          'age',
          'retargeting_tags_include',
          'retargeting_tags_exclude',
          'district',
          'city',
          'gender',
          'platform',
          'hide_if_converted',
          'location_type',
          'android_osv',
          'ios_osv'
        ]
      }
      const { search_bid_ratio, keywords, audience_extend, keywordSwitch } = this.formItem

      if (this.formItem.delivery_mode === 'MANUAL' && keywordSwitch) {
        // 搜索快投
        if (search_bid_ratio) {
          const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
          if (Number(search_bid_ratio) >= 1 && Number(search_bid_ratio) <= 2) {
            if (!twoDigit.test(search_bid_ratio)) {
              this.errRes.push({ feild: '搜索快投', msg: '出价系数值小数点后最多两位' })
            }
          } else {
            this.errRes.push({ feild: '搜索快投', msg: '出价系数取值范围1.00 ~ 2.00' })
          }
        }
      } else {
      }

      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }
      const params = {
        name,
        accountId: this.accountId,
        project_id: this.projectId,
        audience: pullKeys(target_keys, targetParams),
        delivery_setting: {
          budget_mode: delivery_setting.budget_mode,
          budget: delivery_setting.budget,
          cpa_bid: delivery_setting.cpa_bid || undefined,
          deep_cpabid: delivery_setting.deep_cpabid || undefined,
          roi_goal: delivery_setting.roi_goal || undefined
        }
      }

      // 如果是手动投放，添加搜索快投的参数
      if (this.formItem.ad_type === 'ALL' && this.formItem.delivery_mode === 'MANUAL' && keywordSwitch) {
        if (search_bid_ratio) {
          params.search_bid_ratio = Number(search_bid_ratio)
        }
        params.audience_extend = audience_extend
        params.keywords = keywords
      }
      this.loading = true
      updateProject(params).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('保存成功,正在关闭页面...')
          setTimeout(() => {
            window.close()
          }, 1500)
        }
      })
    }
  },
  data() {
    return {
      loading: false,
      audienceLoading: false,
      mediaId: 10,
      projectId: this.$router.currentRoute.query.id,
      accountId: this.$router.currentRoute.query.acId,
      show: null,
      asyning: null, // 异步加载
      check: null, // 计划名检查
      showSearchBidKeywordModal: false, // 搜索快投关键词弹窗
      searchBidKeywordList: [], // 搜索快投关键词
      starTaskList: [],
      formItem: {
        // 基础信息
        name: '', // 项目名称
        ch_platform_id: 1, // 平台类型
        game_id: '', // 草花投放游戏ID
        game_name: '',
        optimize_goal_name: '',
        package: '', // 广告应用下载包名
        monitorPlan: [], // 自动化任务
        callback_switch: 1, // 回调开关
        landing_type: 'APP', // 推广目的
        app_promotion_type: 'DOWNLOAD', // 子目的
        marketing_goal: 'VIDEO_AND_IMAGE', // 营销场景
        ad_type: 'ALL', // 所有广告
        media_pack_switch: 1, // 头条分包
        game_address: '', // 游戏下载地址
        call_type: '1', // 上报媒体方式
        download_url: '', // 广告应用下载链接
        app_type: 'APP_ANDROID', // 广告应用下载类型

        audience: defaultTargetParams,

        star_task_id: '',

        // 排期与预算
        delivery_setting: {
          schedule_type: 'SCHEDULE_FROM_NOW',
          schedule_time: '',
          start_time: formatDate(new Date(), 'yyyy-MM-dd'),
          end_time: formatDate(new Date(), 'yyyy-MM-dd'),
          bid_type: 'CUSTOM', // 竞价策略
          budget_mode: 'BUDGET_MODE_INFINITE', // 项目预算
          budget: '', // 日预算
          deep_bid_type: '' // 深度优化方式
        },
        // 搜索快投
        keywordSwitch: 0,
        search_bid_ratio: '',
        audience_extend: 'ON',
        keywords: [],
        timeRange: 'NONE' // 投放时间段 默认不传此参数
      },
      weektimeData: weektimeData,

      // 用户定向
      retargetData: [],
      unionRetargetData: [],
      cityData: cityData,
      gategoryData: gategoryData,
      brandData,
      brandDataAll,
      articleData: articleData,
      autotendData: autotendData,
      androidVersion: androidVersion,
      iOSVersion: iOSVersion
    }
  },
  created() {
    this.$Spin.show()
    this.preload()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.c-project {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .c-project-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }
}

::v-deep .col-flex {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.ivu-affix .c-idea-bar {
  border-bottom: 1px solid #e8eaec;
}

::v-deep .ivu-btn {
  margin-right: 8px;
}

.star-auto-material-switch {
  display: flex;
  align-items: center;
  margin-top: 6px;
  p {
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>
